module.exports = __webpack_public_path__ + "img/sq3.e3a5408e.png";